
import { Component, Vue, Watch, Prop, Emit, PropSync, Model } from 'vue-property-decorator';
import { VariazioneDaComunicare, TipoVariazione, RigaDistintaPerComunicazioneVariazione, ItemDatiLookup,
  Distinta, RigaDistintaQtaTaglia, VariazioneDaComunicareQtaTaglia, RigaDistinta } from '@/models';
import { store, StoreActions } from '@/store'
import TabellaValori from './TabellaValori.vue';

@Component({
  components: {
    TabellaValori
  }
})
export default class VariazioniMassive extends Vue{
    
  @PropSync("variazioneRiferimento") private variazione!: VariazioneDaComunicare;
  
  private get variazioniCorrelateTutteEliminate(): boolean
  {
      return this.variazione.variazioniCorrelate.every(v => v.eliminataDaAs400);
  }

  private cambiaStatoVariazione(variazioneCorrelata: VariazioneDaComunicare) {

    // hack: :( uso flag mostraCorrelate per gestire lo switch e nell'evento poter cambiare correttamente lo stato della variazione 
    if(variazioneCorrelata.mostraCorrelate) {
       if(this.variazione.tipoVariazione == TipoVariazione.NUOVA) {
        variazioneCorrelata.tipoVariazione = TipoVariazione.NUOVA;
      }
      else {
        variazioneCorrelata.tipoVariazione = TipoVariazione.ELIMINATA;
      }
    }
    else {
      if(this.variazione.tipoVariazione == TipoVariazione.NUOVA) {
        variazioneCorrelata.tipoVariazione = TipoVariazione.ELIMINATA;
      }
      else {
        variazioneCorrelata.tipoVariazione = TipoVariazione.MODIFICABILE;
      }
    }
  }

  descProvenienza(variazione: VariazioneDaComunicare): string {
    let desc: string = "";
    
    let distinta = store.state.uiConsumi.listaDistinteCorrelate.find((distinta: Distinta) => distinta.id == variazione.idDistintaAppartenenza);
    if(distinta) {
      // let rigaCorrelata = distinta.righeDistintaDPC.find((riga: RigaDistinta) => riga.innerRigaDistinta.idComponenteBga == idComponente);
      // MODELLO DI VENDITA (MOD. DISTINTA)
      desc = "Modello distinta correlata: <strong>";
      desc += distinta.idModello;
      desc += " - ";
      desc += distinta.descrizioneModello;
      // COLORE DI VENDITA (COL. DISTINTA)
      desc += "</strong>. Colore di vendita: <strong>";
      desc += distinta.idColore;
      desc += " - ";
      desc += distinta.descrizioneColore;
      desc += "</strong>"
    }

    return desc;
  }

  isModified(variazione: VariazioneDaComunicare): boolean {
    return variazione.variazioneRigaDistintaQtaTaglia.some((variazione: VariazioneDaComunicareQtaTaglia) =>
        variazione.qta != variazione.qtaModificata
    );
  }
  
  isDeleted(v: VariazioneDaComunicare): boolean {
    return v.tipoVariazione == TipoVariazione.ELIMINATA;
  }

  isNotSelectedForNew(v: VariazioneDaComunicare): boolean {
    return this.variazione.tipoVariazione == TipoVariazione.NUOVA && v.tipoVariazione == TipoVariazione.ELIMINATA;
  }

  isNew(variazione: VariazioneDaComunicare): boolean {
    return variazione.tipoVariazione == TipoVariazione.NUOVA;
  }
}
